import axios from 'axios';

export async function postData(url: string, data?: any): Promise<any> {
  try {
    const response = await axios.post(url, data);
    return response;
  } catch (err) {
    return err;
  }
}
